/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('DeliveryTemplatesService', function (this: JS5Object, _: JS5Object, DeliveryTemplatesResourceFactory: JS5Object) {
    this.originalEditData = {};
    this.getAllDeliveryTemplates = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return DeliveryTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getDeliveryTemplate = (deliveryTemplateId: number) => {
        return DeliveryTemplatesResourceFactory.get({deliveryTemplateId: deliveryTemplateId}).$promise;
    };
    this.createDeliveryTemplate = (deliveryTemplate: JS5Object) => {
        return DeliveryTemplatesResourceFactory.save(deliveryTemplate).$promise;
    };
    this.cloneDeliveryTemplate = (deliveryTemplate: JS5Object) => {
        return DeliveryTemplatesResourceFactory.clone({id: deliveryTemplate.id}).$promise;
    };
    this.updateDeliveryTemplate = (deliveryTemplate: JS5Object) => {
        return DeliveryTemplatesResourceFactory.update(deliveryTemplate).$promise;
    };
    this.deleteDeliveryTemplate = (deliveryTemplateId: number) => {
        return DeliveryTemplatesResourceFactory.delete({deliveryTemplateId: deliveryTemplateId}).$promise;
    };
});
